export default __webpack_public_path__ + "static/media/fck.483feabc.jpg";